/**
 * This type override was necessary because this library is not yet updated for React 18 support
 * TODO: // remove this file when we upgrade this library when it supports React 18 https://aboutyou.atlassian.net/browse/ASFE-5141
 */

import {ViewportProvider as OriginalViewportProvider} from 'react-viewport-utils';

interface Props {
  experimentalSchedulerEnabled?: boolean;
  experimentalSchedulerLayoutCalculatorEnabled?: boolean;
  children?: React.ReactNode;
}
export const ViewportProvider =
  OriginalViewportProvider as unknown as React.ElementType<Props>;
